import PropTypes from 'prop-types';

/**
 * Since there's no way to get these from the server, I have added an enum here for convenience.
 */
export const damageAreaLocations = {
  INTERIOR: 'INTERIOR',
  EXTERIOR: 'EXTERIOR',
};

/**
 * An enum has been added more for convenience as these constant values do not exist on the database
 */
export const videoOptionsUploadPreference = {
  WIFI_ONLY: true,
  WIFI_AND_MOBILE: false,
};

/**
 * An enum to denote making a code available or not to a wider audience.
 * Added more for convenience as these constant values do not exist on the database
 */
export const codeAvailabilityActions = {
  PUBLISH: true,
  UNPUBLISH: false,
};

/**
 * A custom filter for select fields.
 * This searches on the option text rather than the default behaviour of using the id.
 * @param {string} input The filter text input.
 * @param {component} option An 'option' component.
 */
export const filterSelectField = (input, option) => (
  option.props.children.toLowerCase().includes(input.toLowerCase())
);

/**
 * A custom filter for 'published' state on an object.
 * @param {string} value The input value.
 * @param {object} record The filter object.
 */
export const filterPublished = (value, record) => record.active === value;

/** Sort object Alphabetically on a specified attribute
 *  @param arrayToSort array being sorted (returned)
 *  @param attribute attribute named
 *  @param  reverse true if wish to be descending
 */
export const sortAlphabeticallyByAttribute = (arrayToSort, attribute, reverse) => {
  const leftValue = reverse ? 1 : -1;
  const rightValue = reverse ? -1 : 1;
  arrayToSort.sort((a, b) => {
    const textA = a[attribute].toLowerCase();
    const textB = b[attribute].toLowerCase();
    if (textA < textB) return leftValue;
    if (textA > textB) return rightValue;
    return 0;
  });
  return arrayToSort;
};

export const damageAreaShape = PropTypes.shape({
  damageAreaCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  damageAreaDescription: PropTypes.string.isRequired,
  damageAreaLocation: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
});

export const damageTypeShape = PropTypes.shape({
  damageTypeCode: PropTypes.string.isRequired,
  damageTypeDescription: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
});

export const modelTypeShape = PropTypes.shape({
  modelTypeCode: PropTypes.number.isRequired,
  modelTypeDescription: PropTypes.string.isRequired,
});

export const locationShape = PropTypes.shape({
  locationCode: PropTypes.number.isRequired,
  locationDescription: PropTypes.string.isRequired,
});
